import { Block, BlockType } from 'src/config/api/models/Block';

export const addFakeCluster = (blocks: Block[]) => {
  const fakeCluster: Block = {
    id: 'fake_cluster',
    type: BlockType.CLUSTER,
    title: '',
    exercise_tool: null,
    parent_id: '',
    hideClusterTitle: true,
    sections: [
      {
        id: 'fake_section',
        type: BlockType.SECTION,
        is_visible: true,
        is_printable: true,
        content: '',
        parent_id: 'parent_fake_section',
        is_defaultsection: false,
        childBlocks: blocks,
        exercise_tool: null,
      },
    ],
  };
  return fakeCluster;
};
